/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function GatewayInfoController($rootScope, $q, $document, $scope, $mdDialog,
                                                  toast, types, gatewayCommandService, gatewayId) {

    var vm = this;

    vm.$onInit = function () {
        vm.gatewayId = gatewayId;
        vm.types = types;

        vm.close = close;

        vm.loading = function () {
            return $rootScope.loading;
        };

        getGatewayInfo();
    };

    function close() {
        $mdDialog.cancel();
    }

    function getGatewayInfo() {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.gatewayInfoCommand.getGatewayInfo.value, {}).then(
            (data) => {
                vm.gatewayInfo = data;
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function onError(error) {
        vm.radioStatisticsPollExecuting = false;
        var toastParent = angular.element('#tk-gateway-info-dialog', $document);
        var dialogContent = toastParent.find('md-dialog-content');
        if (dialogContent.length > 0) {
            toastParent = dialogContent;
        }
        toast.showError(error, toastParent, 'bottom right');
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/gateway-info/gateway-info.controller.js